import { useMutation, useQuery } from "react-query";
import {
  createPurchaseAgentsService,
  getStatusPurchaseAgentService,
} from "./purchase-agents-service";
import { IUsePurchaseAgentReq } from "./use-purchase-agents.interface";

export const useCreatePurchaseAgents = (config?: any) => {
  return useMutation(
    (data: IUsePurchaseAgentReq) => createPurchaseAgentsService(data),
    config,
  );
};

export const useGetStatusPurchaseAgent = (
  sessionTransaction: string,
  config?: any,
) => {
  return useQuery(
    "getStatusPurchaseAgent",
    () => getStatusPurchaseAgentService(sessionTransaction),
    config,
  );
};
